const ADD_USER_DIET = (state, diet) => {
  state.user.dietsInfo.push(diet.name);
};

const REMOVE_USER_DIET = (state, diet) => {
  state.user.dietsInfo = state.user.dietsInfo.filter((dietInfo) => dietInfo !== diet.name);
};

export default {
  ADD_USER_DIET,
  REMOVE_USER_DIET,
};



// WEBPACK FOOTER //
// ./store/modules/user/mutations.js